import Image from '@commons/image/Image'
import Price from '@commons/product/price/Price'

import CTA from '@commons/cta/CTA.tsx'
import Link from '@commons/link/Link.tsx'

import { Bundle, useModal } from '@components/featured-products/ModalContext'
import { usePbProps } from '@content/helpers/src/context.tsx'
import { getProduct } from '@nespresso/catalog-sdk'
import { Card, Tag, TagProps } from '@nespresso-design-system/components'

import { useEffect, useState } from 'preact/hooks'
import { addSKUtoCart } from '@content/helpers/src/updateCart'
import styles from './ProductCard.module.scss'
import { selectPromotion } from '@content/helpers/src/gtmEvents.js'

export type ProductCardProps = {
    index: number
    card: {
        sku: string
        bundles: Bundle[]
        tag: TagProps
        bundleHeadline: string
    }
    modalId: string
}

const ProductCard = ({ card, modalId, index }: ProductCardProps) => {
    const [product, setProduct] = useState(undefined)
    const { copywriting, campaign }: any = usePbProps()
    const { sku, bundles, tag, bundleHeadline, quantity } = card

    const { openModal } = useModal()

    const handleClick = e => {
        e.preventDefault()

        if (bundles.length) {
            openModal(modalId, sku, bundles, bundleHeadline)

            selectPromotion({
                ...campaign,
                cta_name: `bundle - ${index + 1} - ${product.name}`
            })
        }
    }

    const AddToCart = async (e, product) => {
        e.stopPropagation()
        e.preventDefault()

        await addSKUtoCart(product.legacyId, quantity)
    }

    const AddToCartBundle = async (e, bundles, product) => {
        e.stopPropagation()
        e.preventDefault()

        await addSKUtoCart(product.legacyId, quantity)
    }

    useEffect(() => {
        async function fetchProduct() {
            const productData = await getProduct(sku)
            setProduct(productData)
        }

        if (sku) {
            fetchProduct()
        }
    }, [sku])

    const isBundleCardClass = !bundles?.length
        ? styles.isSingleProduct
        : styles.isBundle

    return (
        <div className={styles.cardWrapper}>
            <Card
                href="#"
                onClick={handleClick}
                className={`${styles.card} ${isBundleCardClass}`}>
                <div className={styles.cardInner}>
                    <div className={styles.cardHeader}>
                        <Tag className={styles.cardHeaderTag} {...tag} />

                        <Image
                            src={product?.images?.icon}
                            alt={product?.name}
                        />
                    </div>

                    <div className={styles.cardContentWrapper}>
                        <div className={styles.cardContent}>
                            <div className={styles.cardContentFullDetails}>
                                <div className={styles.cardContentDetails}>
                                    {product?.name && (
                                        <h4 className={styles.name}>
                                            {product.name}
                                        </h4>
                                    )}
                                    {product?.headline ? (
                                        <p className={styles.headline}>
                                            {product?.headline}
                                        </p>
                                    ) : null}

                                    <div className={styles.cardContentPricing}>
                                        <Price
                                            priceDark
                                            price={product?.price}></Price>
                                    </div>
                                </div>
                            </div>

                            <div className={styles.cardContentATC}>
                                <CTA
                                    {...copywriting.cta_secondary}
                                    defaultVariant="secondary"
                                    onClick={e =>
                                        bundles?.length
                                            ? AddToCartBundle(
                                                  e,
                                                  bundles,
                                                  product
                                              )
                                            : AddToCart(e, product)
                                    }
                                />

                                {!!bundles?.length &&
                                    copywriting.bundle_seeDetails && (
                                        <div className={styles.linkSeeDetails}>
                                            <Link
                                                {...copywriting.bundle_seeDetails}
                                                variant={'black'}
                                                hasUnderline={true}
                                            />
                                        </div>
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
        </div>
    )
}

export default ProductCard
